/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Whole_Word_LabelInputs */



/**
* | output |
* | --- |
* | "Whole Word" |
*
* @param {Find_Replace_Whole_Word_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_whole_word_label = /** @type {((inputs?: Find_Replace_Whole_Word_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Whole_Word_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot entier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ganzes Wort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Parola intera")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целое Слово")
	if (locale === "es") return /** @type {LocalizedString} */ ("Palabra completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("整个单词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語全体")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूरा शब्द")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palavra inteira")
	return /** @type {LocalizedString} */ ("Whole Word")
});